import React from 'react'
import Fade from 'react-reveal/Fade'
import { AboutWrapper,AboutContainer,AboutTitle,AboutGridText,AboutSubtitle,AboutGridParr,AboutTextImage,AboutImage,Img,AboutTextEnd,AboutEndPar,AboutEndParchild} from './AboutjyElements'
const  Aboutjy = ({id,titlehead,subtitlehead,parr,parr1,parr2,ImgGan,parr3,parr3child}) => {
  return (
    <>
      <AboutWrapper id={id}>
       <Fade bottom>
        <AboutContainer>
            <AboutTitle>
              {titlehead}
            </AboutTitle>
            <AboutSubtitle>
              {subtitlehead}
            </AboutSubtitle>
            <AboutGridText>
              <AboutGridParr>
                {parr}
              </AboutGridParr>
              <AboutGridParr>
                {parr1}
              </AboutGridParr>
              <AboutGridParr>
                {parr2}
              </AboutGridParr>
            </AboutGridText>
            <AboutTextImage>
              <AboutImage>
                <Img loading="lazy" src={ImgGan} alt='Jaime Ivan Ramirez Osorio eljimmyramz' title='Jaime Ivan Ramirez Osorio eljimmyramz' width="100%" height="100%"/>
              </AboutImage>
              <AboutTextEnd>
                <AboutEndPar>
                  {parr3}
                  <AboutEndParchild>
                    {parr3child}
                  </AboutEndParchild>
                </AboutEndPar>
              </AboutTextEnd>
            </AboutTextImage>
          </AboutContainer>
       </Fade>
      </AboutWrapper>
    </>
  )
}

export default Aboutjy